import { FormInstance } from 'antd';
import {
  OnboardingFormSiteAddress,
  SiteAddressData,
  ContactPersonData,
  TIER_VALUES,
  STATION_USAGE_TYPES,
  TIER_OPTIONS,
} from '@/store/SiteSurveyForm/constants';
import SiteSurveyStore from '@/store/SiteSurveyForm/SiteSurveyStore';
import { Rule } from 'antd/lib/form';
import { BrandNamesSet } from '@/store/User/UserStore.utils';

export interface CustomerInformationContentProps {
  siteSurveyStore: SiteSurveyStore;
  formId?: string | null;
  form?: FormInstance;
}

export const initializeFormFields = (form: FormInstance, siteSurveyStore: SiteSurveyStore): void => {
  const displayTier = getDisplayTierFromTierAndUsage(
    siteSurveyStore.customerInformationData.tier,
    siteSurveyStore.customerInformationData.stationUsageType,
  );

  form.setFieldsValue({
    tier: displayTier || undefined,
    account: siteSurveyStore.customerInformationData.account || undefined,
    siteAddress: siteSurveyStore.customerInformationData.siteAddress || undefined,
    accountManager: siteSurveyStore.customerInformationData.accountManager || undefined,
  });
};

export const getStationUsageTypeFromTier = (tier: string): string => {
  return tier === TIER_VALUES.MONITOR_INTERNAL ? STATION_USAGE_TYPES.INTERNAL : STATION_USAGE_TYPES.REGULAR;
};

export interface TierAndUsageType {
  tier: string;
  stationUsageType: string;
}

export const getTierAndUsageFromSelection = (selection: string): TierAndUsageType => {
  if (selection === TIER_VALUES.MONITOR_INTERNAL) {
    return {
      tier: TIER_VALUES.MONITOR,
      stationUsageType: STATION_USAGE_TYPES.INTERNAL,
    };
  }
  return {
    tier: selection,
    stationUsageType: STATION_USAGE_TYPES.REGULAR,
  };
};

export const getDisplayTierFromTierAndUsage = (tier: string, stationUsageType: string): string => {
  if (tier === TIER_VALUES.MONITOR && stationUsageType === STATION_USAGE_TYPES.INTERNAL) {
    return TIER_VALUES.MONITOR_INTERNAL;
  }
  return tier;
};

export const formatAddressContent = (addressData: SiteAddressData): OnboardingFormSiteAddress => {
  return {
    streetAddress: addressData.streetAddress,
    city: addressData.city,
    state: addressData.state,
    country: addressData.country ?? '',
    cityState: `${addressData.city ?? ''}${addressData.state ? `, ${addressData.state}` : ''}`,
    zipCode: addressData.zipCode,
  };
};

export const setDynamicTierOptions = (whiteLabelingTerms: BrandNamesSet | undefined): typeof TIER_OPTIONS => {
  if (!whiteLabelingTerms?.packageNames) {
    return TIER_OPTIONS;
  }

  return [
    {
      value: TIER_VALUES.MONITOR,
      label: whiteLabelingTerms.packageNames.monitor,
    },
    {
      value: TIER_VALUES.OPTIMIZE,
      label: whiteLabelingTerms.packageNames.optimize,
    },
    {
      value: TIER_VALUES.MONITOR_INTERNAL,
      label: `${whiteLabelingTerms.packageNames.monitor} (Internal)`,
    },
  ];
};

export interface FormFieldConfig {
  name: string;
  label: string;
  type?: 'input' | 'select';
  placeholder?: string;
  rules?: Rule[];
  options?: { label: string; value: string }[];
}

export type ModalData = SiteAddressData | ContactPersonData;
